import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/30_kittens/30_kittens"
 * Contains 1 texture(s)
 */
export class Desktop30KittensAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/30_kittens/30_kittens';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '30_kittens.jpg'
    ] as const;
}
